<template>
  <div class="page-content-wrapper">
    <div class="page-content passwd">
      <!-- BEGIN PAGE HEADER-->
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <i class="fa fa-home"></i>
            <a href="index.html">首页</a>
            <i class="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">修改密码</a>
          </li>
        </ul>
      </div>
    <div>
      <br>
    <form class="form-horizontal">
      <input type="hidden" name="id" id="id"/>
      <div class="form-group lp-flex-box" style='align:left'>
          <label class="control-label col-sm-3">账号</label>
          <div class="controls col-sm-6">
              <input type="text" readonly="readonly" name="username" id="username" v-model="biz.username" class="form-control" />
          </div>
          <span class="help-inline" style="visibility:hidden">必填,8位以上</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.name==''}" style='align:left'>
          <label class="control-label col-sm-3">旧密码</label>
          <div class="controls col-sm-6">
              <input type="password" name="pwd" id="pwd" v-model="biz.pwd" class="form-control input-sm" />
          </div>
          <span class="help-inline">必填,8位以上</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.name==''}" style='align:left'>
          <label class="control-label col-sm-3">新密码</label>
          <div class="controls col-sm-6">
              <input type="password" name="newPwd" id="newPwd" v-model="biz.newPwd" class="form-control input-sm" />
          </div>
          <span class="help-inline">必填,8位以上</span> 
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.name==''}" style='align:left'>
          <label class="control-label col-sm-3">重复新密码</label>
          <div class="controls col-sm-6">
              <input type="password" name="newPwd0" id="newPwd0" v-model="biz.newPwd0" class="form-control input-sm" />
          </div>
          <span class="help-inline">必填,8位以上</span> 
      </div>
      
      <div class="form-group lp-flex-box" style='align:left'>
        <button class="btn green" type="button" @click="save">确定</button>
      </div>
    </form>
  </div>
</div>
</div>
</template>

<script>
import http from '../../lib/utils/request.js'
import commonMethods from '../../lib/methods/common.js'
import db from '../../store/local'
import mixins from '../../mixins/index'
import {MSG_ID, K_LOGINED_USER} from '../../lib/constant.js'
require('../../lib/utils/cryptojs/cryptojs.js') // code executes and sets the object 'Crypto' in window object
let crypto = window.Crypto
export default {
  name: 'password',
  mixins: mixins,
  data () {
    return {
      biz: {
        id: 0,
        username: '',
        pwd: '',
        newPwd: '',
        newPwd0: ''
      }
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      let user = db.get(K_LOGINED_USER)
      console.log(user.account)
      this.biz.username = user.account.username
      this.biz.id = user.account.id
    },
    save () {
      if (!this.biz.pwd || !this.biz.newPwd || !this.biz.newPwd0) {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '信息填写不完整')
        return
      }
      if (this.biz.newPwd.length < 8) {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '密码必须大于8位数')
        return
      }
      if (this.biz.newPwd !== this.biz.newPwd0) {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '两次密码不一致')
        return
      }
      let reqdata = {id: this.biz.id, pwd: crypto.MD5(this.biz.pwd), new_pwd: crypto.MD5(this.biz.newPwd)}
      http.post('auth.changePwd', reqdata, {}, (data) => {
        window.emitter.emit(MSG_ID.MSG_UI_TOAST_SUCC, '修改密码成功，请重新登录！')
      }, (state) => {
        switch (state.result) {
          case 2:
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '账号不存在')
            break
          case 3:
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '原密码错误')
            break
          case 4:
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '账号已经冻结')
            break
        }
      })
    },
    ...commonMethods
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Passwd.vue?5f574e5b